module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Alocar bolsa para projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.formularioValido),
      callback: function($$v) {
        _vm.formularioValido = $$v
      },
      expression: "formularioValido"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Projeto",
      "value": _vm.projeto.titulo,
      "readonly": "",
      "max-height": "400"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm9": "",
      "xs11": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Bolsa",
      "items": _vm.listaBolsas,
      "item-text": "descricao",
      "item-value": "idBolsa",
      "prepend-icon": "dashboard",
      "max-height": "400",
      "required": "",
      "autocomplete": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.idBolsa),
      callback: function($$v) {
        _vm.idBolsa = $$v
      },
      expression: "idBolsa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs11": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Quantidade",
      "max-height": "400",
      "required": "",
      "rules": _vm.regrasBasicas
    },
    model: {
      value: (_vm.quantidadeBolsas),
      callback: function($$v) {
        _vm.quantidadeBolsas = $$v
      },
      expression: "quantidadeBolsas"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": "",
      "disabled": !_vm.formularioValido
    },
    on: {
      "click": _vm.confirmar
    }
  }, [_vm._v("Alocar")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20b793b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/bolsas/alocar-bolsa.vue
// module id = 381
// module chunks = 0